import { create } from "zustand";

interface MapNoteTemplateManagerState {
  open: boolean;
  /** Currently focused template inside the manager modal. */
  selectedTemplateId: string | null;
  openManager: (templateId?: string | null) => void;
  closeManager: () => void;
  selectTemplate: (templateId: string | null) => void;
}

export const useMapNoteTemplateManagerStore = create<MapNoteTemplateManagerState>((set) => ({
  open: false,
  selectedTemplateId: null,
  openManager(templateId) {
    set({ open: true, selectedTemplateId: templateId ?? null });
  },
  closeManager() {
    set({ open: false });
  },
  selectTemplate(templateId) {
    set({ selectedTemplateId: templateId });
  },
}));
